import React from 'react';
import styles from './styles.module.css';

interface ProgressTaskBarProps {
  completed: number;
  total: number;
  title: string;
  icon: React.ReactNode;
}

function ProgressTaskBar({completed, total, title, icon}: ProgressTaskBarProps) {
  const progressPercentage = (completed / total) * 100;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          {icon && <span className={styles.icon}>{icon}</span>}
          <span className={styles.title}>{title}</span>
        </div>
        <div className={styles.counter}>
          {completed}/{total}
        </div>
      </div>
      <div className={styles.progressBarContainer}>
        <div className={styles.progressBar} style={{width: `${progressPercentage}%`}} />
      </div>
    </div>
  );
}

export {ProgressTaskBar};
